// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-api-tsx": () => import("./../../../src/templates/api.tsx" /* webpackChunkName: "component---src-templates-api-tsx" */),
  "component---src-templates-doc-tsx": () => import("./../../../src/templates/doc.tsx" /* webpackChunkName: "component---src-templates-doc-tsx" */),
  "component---src-templates-package-tsx": () => import("./../../../src/templates/package.tsx" /* webpackChunkName: "component---src-templates-package-tsx" */)
}

